import './style.css';
import React from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import type { NotificationTO } from '../../../lib';
import { post } from '../../../api/baseUrl';
import { useNavigate } from 'react-router-dom';
import { SystemPermission, useTriggerUpdate } from '../../../context';
import NotificationItem from './NotificationItem';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';
import { NoNotificationItem } from './NoNotificationItem';

interface NotificationContainerProps {
  notifications: NotificationTO[];
  show: boolean;
  onClose: () => void;
}
const NotificationContainer = ({
  notifications,
  show,
  onClose,
}: NotificationContainerProps) => {
  const { triggerNotificationUpdate } = useTriggerUpdate();
  const navigate = useNavigate();

  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const canViewPatientRecord =
    !selectedTenancy?.permissionsSetup ||
    (selectedTenancy?.permissionsSetup &&
      selectedTenancy?.userPermissions &&
      !!(selectedTenancy?.userPermissions)[
        SystemPermission.VIEW_PATIENT_RECORD
      ]);

  const onClickItem = async (notification: NotificationTO) => {
    try {
      let pageUrl = `/${notification.action.page}`;
      if (notification.action.page == 'patientDetails') {
        pageUrl += `?access_token=${notification.action.value}`;
      }
      if (notification.action.type === 'url' && canViewPatientRecord) {
        navigate(pageUrl);
      }
      onClose();
      if (!notification.read_at) {
        await post('/markNotificationRead', { id: notification.id });
        triggerNotificationUpdate();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ToastContainer style={{ zIndex: 1 }} className="popup-box">
      <Toast show={show}>
        <Toast.Header closeButton={false} className="notification-active">
          Notifications
        </Toast.Header>
        {notifications.map((notification) => (
          <NotificationItem
            key={`notification-${notification.id}`}
            onClickItem={onClickItem}
            notification={notification}
          />
        ))}
        {notifications.length === 0 && <NoNotificationItem />}
      </Toast>
    </ToastContainer>
  );
};

export default NotificationContainer;
